var mcb = mcb || {};

mcb.matomodatalayer =
  mcb.matomodatalayer ||
  new (function () {
    this.init = function () {

        var _paq = window._paq = window._paq || [];

        window._paq = _paq;

        document.addEventListener("click", function(event) {
            var target = event.target ? event.target : event;

            if (target.tagName.toUpperCase() != 'INPUT' && target.matches("[data-matomo-category][data-matomo-action][data-matomo-name]")) {
                _paq.push(['trackEvent', target.dataset.matomoCategory, target.dataset.matomoAction, target.dataset.matomoName]);
            }            
        });

        document.addEventListener("change", function(event) {
            var target = event.target ? event.target : event;

            if (target.matches("[data-matomo-category][data-matomo-action][data-matomo-name]")) {
                _paq.push(['trackEvent', target.dataset.matomoCategory, target.dataset.matomoAction, target.dataset.matomoName]);
            }            
        });
    };
  })();
